// extracted by mini-css-extract-plugin
export default {"bulletList":"Bullets_bulletList__g6NoM","bulletItem":"Bullets_bulletItem__3q3fC","icon":"Bullets_icon__55gzo","content":"Bullets_content__tINKH"};